module.exports = __webpack_public_path__ + "static/img/mask.d1bd6ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/mask.png
// module id = JW9R
// module chunks = 1